module.exports = __webpack_public_path__ + "static/img/8.036fa00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/8.png
// module id = Z7vi
// module chunks = 0